import React, { createContext, useState } from "react";
const Context = createContext();
const { Provider } = Context;

function ThemeContextProvider(props) {
    const [lang, setLang] = useState(localStorage.getItem("themeLang") ? localStorage.getItem("themeLang") : "fr");
    const [isShow,setIsShow] = useState(true); // initially true
    const [showLoader,setShowLoader] = useState(false); //initially false
    const [theme,setTheme] = useState("green");
    const [showSideBar,setShowSideBar] = useState(false);//initially false
    const [showLangModal,setShowLangModal] = useState(false);//initially false

    const [modalData,setModalData] = useState({
      title : "Oops",
      body : "Something went wrong.",
      btn : ["YES","NO"]
    })
    const [showModal,setShowModal] = useState(false);//initially false

    const [verified,setVerified] = useState(false);//initially false
    const [isNewUser,setIsNewUser] = useState(false);//initially false

    const handleIsShowHeader = (value) => {
      setIsShow(value)
    }
    const handleShowLoader = (value) => {
      setShowLoader(value);
    }
    const handleThemeColor = (color) => {
      setTheme(color)
    }
    const handleSideMenu = (value) => {
      setShowSideBar(value);
    }
    const handleLanguage = (langValue) => {
      localStorage.setItem("themeLang",langValue);
      setLang(langValue);
      handleLangModal(false);
      setShowModal(false);
      window.location.reload();
    }
    const handleLangModal = (value) => {
      setShowLangModal(value);
    }

    const handleModal = (modalData,showModal) => {
      setShowModal(showModal);
      setModalData(modalData);
      handleSideMenu(false)
    }

    const handleVerifyUser = (value) => {
      setVerified(value);
    }

    const handleNewUser = (value) => {
      setIsNewUser(value);
    }
    const { children } = props;

  return (
    <Provider
      value={{
        lang,
        handleLanguage,
        isShow,
        handleIsShowHeader,
        showLoader,
        handleShowLoader,
        theme,
        handleThemeColor,
        showSideBar,
        handleSideMenu,
        showLangModal,
        handleLangModal,
        modalData,
        handleModal,
        showModal,
        verified,
        handleVerifyUser,
        isNewUser,
        handleNewUser
      }}
    >
      {children}
    </Provider>
  );

}

export { Context, ThemeContextProvider };